import React from 'react'


export default function Spinner(props: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div {...props} className={'spinner ' + (props.className || "")} />
    )
}